// extracted by mini-css-extract-plugin
export default {"button":"menu-button_button__CFieJ","open":"menu-button_open__A2pqV","closed":"menu-button_closed__22fjS"};